//Verzije api-a
const V1 = '/api/v1';
const V2 = '/api/v2';

/**
 * Centralized configuration of backend REST API endpoints used across the application.
 * Each property corresponds to a specific API endpoint, with functions for dynamic URLs.
 * This allows for easy maintenance and updates to API paths in a single location.
 */
export const backendRestApis = {
    
    //websocket
    ws: {
        ws: `${V1}/ws`
    },
    
    auth: {
        login:   `${V1}/auth/login`,
        logout:  `${V1}/auth/logout`,
        refreshToken: `${V1}/auth/refreshToken`,
        register: `${V1}/auth/register`
    },

    gps: {
        getAllGpsWithRouteId: (routeId: number) => `${V1}/gps/routeId/${routeId}`
    },

    ride: {
        getById: (rideId: number) => `${V1}/ride/${rideId}`,
        getAllRides: `${V1}/ride`,
        getAllRidesWithOrderByDateDesc: `${V1}/ride/allOrderByDateDesc`,
        getAllGpsForRideWithId: (rideId: number) => `${V1}/ride/${rideId}/routes/gps`,
        updateRideName: (rideId: number) => `${V1}/ride/updateRideName/${rideId}`,
        getLastRide: `${V1}/ride/lastRide`
    },

    route: {
        getAllRoutesWithRideId: (rideId: number) => `${V1}/route/rideId/${rideId}`,
        getRouteWithId: (routeId: number) => `${V1}/route/${routeId}`
    },

    mapImages: {
        getByMapImagePath: (imagePath: string) => `${V1}/map-images/getMapImage/${imagePath}`,
        reportMissingMapImage: (rideId: number) => `${V1}/map-images/reportMissingMapImage/${rideId}`,
        generateCurrentOngoingMapImage: `${V1}/map-images/generateCurrentOngoingMapImage`
    },

    heatmap:{
        getHeatmap: `${V1}/heatmap`
    },

    aiChat: {
        ask: `${V1}/aiChat/ask`
    },

    ridingStatistics: {
        getRidingStatistics: `${V1}/ridingStatistics`
    }
};